var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['content-area', { 'edit-mode': _vm.editMode }]},[(_vm.loading)?_c('spinner'):[_vm._t("toolbar"),_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"scroll-area"},[_vm._t("default")],2)])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }